<script>
/* globals window */
import { mapGetters } from 'vuex';

export default {
	data: function() {
		return {};
	},

	computed: {
		...mapGetters({
		activeModal: 'modal/getActive'
		})
	},

	methods: {
		openModal: function(modal, data) {
			this.modal = modal;
			this.$eventsBus.$emit('open-modal', [modal, data]);
		},

		isModalOpen(modal) {
			return this.activeModal() === modal;
		}
	}
};
</script>
